import styled from "@emotion/styled";
import colors from "/styles/colors";
export const StyledReadMoreComponent = styled.div`
  background: rgba(#333, 0.4);
  height: 66px;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  bottom: 0;
  text-align: center;
  font-size: 1.181rem;
  color: ${colors["white"]};
`;
